import { Divider, Form, Input } from 'antd';
import React, { useState } from 'react';
import { ORDER_DELAY_REASON } from '../../../../../common/constants';
import { formValidatorRules } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';
import SelectComponent from '../../../../../components/SelectComponent';

const { Item } = Form;
const { TextArea } = Input;
const { whitespaceNotAllowed } = formValidatorRules;

const AddDelayReasonModal = ({
  isModalOpen,
  setIsModalOpen,
  isBtnLoading,
  onFinish,
  form,
}) => {
  const [validationTriggered, setValidationTriggered] = useState(false);
  return (
    <ModalComponent
      title="Order Delayed"
      okText="Save"
      cancelText="Cancel"
      open={isModalOpen}
      onOk={form?.submit}
      onCancel={() => {
        setIsModalOpen(false);
        form?.resetFields();
      }}
      confirmLoading={isBtnLoading}
    >
      <Divider />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={() => setValidationTriggered(true)}
        validateTrigger={validationTriggered ? 'onChange' : 'onSubmit'}
      >
        <Item
          name="reason"
          label="Reason for Delay"
          rules={[{ required: true, message: 'Please Select Reason!' }]}
        >
          <SelectComponent
            placeholder="Select Reason"
            showSearch={false}
            options={ORDER_DELAY_REASON}
          />
        </Item>
        <Item
          name="comment"
          label="Additional Note"
          rules={[
            whitespaceNotAllowed,
            { required: true, message: 'Please add a description!' },
          ]}
        >
          <TextArea
            rows={4}
            allowClear
            placeholder="Enter description"
            showCount
            maxLength={700}
          />
        </Item>
      </Form>
    </ModalComponent>
  );
};

export default AddDelayReasonModal;
